module.exports = __webpack_public_path__ + "static/img/iranshao.6d4e181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iranshao.png
// module id = YnUm
// module chunks = 1